<template>
  <div class="w-full grid md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-6 h-full min-h-full">

    <template v-if="$address || userState">
      <div class="h-full border-r border-r-white/10 md:col-span-2 lg:col-span-3 xl:col-span-3">
        <AccountTierCard></AccountTierCard>
      </div>
  
      <div class="w-full lg:col-span-2 xl:col-span-3" >
        <ContributionHistory v-if="$accessToken"></ContributionHistory>
      </div>
    </template>
    <template v-else>

      <div class="w-full h-full min-h-screen col-span-full">


        <div class="w-full h-full flex justify-center items-center flex-col font-light text-center px-8">
        <h1 class="text-3xl">Connect Wallet to Proceed</h1>

        <WalletModal>
          <button class="btn bg-turquoise-600 mt-4 text-black hover:text-white">Connect Wallet</button>
        </WalletModal>

        <div class="pt-12">
          <NuxtLink to="/app">
            <button class="btn btn-link text-red-500">return to home</button>
          </NuxtLink>
        </div>
      </div>

      </div>

    </template>

  </div>
</template>

<script setup>
  definePageMeta({
    layout: "app",
    name: "account",
    middleware: "account"
  });

  useHead({
    title: 'Oxbull | Account',
    meta: [
      { name: 'title', content: "Oxbull | Account" },
      { name: 'description', content: "Customize your Oxbull.Tech experience. Manage your profile settings to optimize your interaction with our blockchain project platform." }
    ],
    htmlAttrs: { lang: "en" }
  })

  const { $address, $accessToken } = useNuxtApp()
  const userState = useState('user')

</script>

<style></style>
